<template>
  <div class="administrator">
    <div class="header">
      <h1 class="heading-title">Користувачі системи</h1>
      <!-- <h3 class="heading">Список користувачів</h3> -->
      <Dialog
        mainButtontext="createIcon"
        confirm-text="Зміни не буде збережено, ви впевнені?"
        dialogTitle="Створюємо нового користувача"
        button-label-do="Створити"
        function-name="fetchAddNewAdmin"
        :key="state.newAdminData"
        formSchemaName="formCreateNewUser"
      />
    </div>
    <UsersTable />
    <!--    <div class="pages-footer">-->
    <!--      <PaginationClients/>-->
    <!--    </div>-->
  </div>
</template>

<script>
import UsersTable from "../components/UsersTable";
// import PaginationClients from "../components/PaginationClients";
import Dialog from "../components/Dialog";
import { inject } from "vue";

export default {
  name: "Users",
  components: {
    UsersTable,
    // PaginationClients,
    Dialog,
  },
  data() {
    return {
     
    };
  },
  setup() {
    const { state, methods } = inject("store");
    return {
      state,
      methods,
    };
  },
};
</script>

<style scoped>
.administrator {
  margin: 20px 20px 0 20px;
}

.heading-title {
  font-weight: 600;
  font-size: 20px;
  font-family: Raleway;
  margin-bottom: 32px;
}

.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}

.heading {
  font-weight: 600;
  font-size: 16px;
  font-family: Raleway;
}

.pages-footer {
  display: flex;
}
</style>
